import { render, staticRenderFns } from "./AfterAliPay.vue?vue&type=template&id=278158f5&"
import script from "./AfterAliPay.vue?vue&type=script&lang=js&"
export * from "./AfterAliPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports